import { Editor } from "@monaco-editor/react";
import { useEffect } from "react";
import React from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";

import { useSession } from "../../../contexts/SessionContext";
import { formatSecondsMinutely } from "../../../services/TimeService";
import translate from "../../../services/Translate";

const HtmlEvaluationRender = ({
  evaluationRender,
  evaluationInfos,
  isCorrectionStarted,
  handleStatusChange,
  setTotalQuestions,
  setCorrectQuestions,
  correctQuestions,
}: any) => {
  const { language } = useSession();

  useEffect(() => {
    if (Array.isArray(evaluationRender) && evaluationRender.length > 0) {
      setTotalQuestions(evaluationRender.length);
      setCorrectQuestions(evaluationRender.filter((item: any) => item.is_correct === true).length);
    } // eslint-disable-next-line
  }, [evaluationRender]);

  if (!Array.isArray(evaluationRender) || evaluationRender.length === 0) {
    return <p> {translate(language, "PAGES.EVAL.DATA_NOT_AVAILABLE")}</p>;
  }

  const renderAnswer = (answer: any, programmingLanguage: string) => {
    if (programmingLanguage && programmingLanguage !== "plaintext") {
      return (
        <div className="mt-3">
          <Editor
            className="custom-editor border rounded"
            height="200px"
            language={programmingLanguage}
            theme="vs-dark"
            value={typeof answer === "string" ? answer : JSON.stringify(answer, null, 2)}
            options={{
              readOnly: true,
              minimap: { enabled: false },
            }}
          />
        </div>
      );
    }
    if (typeof answer === "string") {
      return <p className="mt-3 white-background s-regular p-3 border">{answer}</p>;
    } else if (!Array.isArray(answer)) {
      return <p className="mt-3 white-background s-regular p-3 border">{JSON.stringify(answer)}</p>;
    } else {
      return (
        <div className="answers d-flex flex-wrap mt-3 s-regular">
          {answer.map((item: any, index: any) => (
            <div
              key={index}
              className={`p-2 ${
                item.chosen ? "blue-background white-font" : "white-background"
              } me-2 mb-2 px-3 py-2 border rounded`}
            >
              {item.answer}
            </div>
          ))}
        </div>
      );
    }
  };

  const renderIllustration = (illustrations: any) => {
    if (!illustrations || illustrations.length === 0 || illustrations[0] === "[]") return null;

    try {
      const parsedIllustrations = JSON.parse(illustrations[0]);
      return parsedIllustrations.map((imgTag: any, index: any) => (
        <div key={index} dangerouslySetInnerHTML={{ __html: imgTag }} />
      ));
    } catch (e) {
      return null;
    }
  };

  return (
    <React.Fragment>
      {evaluationRender.map((item: any, index: any) => (
        <div key={index} className="evaluation-item m-3">
          <div className="d-flex">
            <div className="me-3 m-bold size-icon">
              <DropdownButton
                id={`dropdown-correction-button-${index}`}
                title={
                  item.is_correct === null ? (
                    <span className="dst-icon-pencil-line" />
                  ) : item.is_correct ? (
                    <span className="dst-icon-check text-success" />
                  ) : (
                    <span className="dst-icon-x-close text-danger" />
                  )
                }
                className="dropdown-correction-button text-center"
                variant={item.is_correct === null ? "Warning" : item.is_correct ? "Success" : "Danger"}
                disabled={!isCorrectionStarted || !item.isEditable || evaluationInfos.correctionSubmitted}
              >
                <Dropdown.Item
                  onClick={() => {
                    handleStatusChange(true, index);
                    setCorrectQuestions(correctQuestions + 1);
                  }}
                  className="d-flex align-items-center"
                >
                  <span className="me-2 dst-icon-check text-success" />
                  {translate(language, "PAGES.EVAL.DROPDOWN.CORRECT")}
                </Dropdown.Item>
                <Dropdown.Item onClick={() => handleStatusChange(false, index)} className="d-flex align-items-center">
                  <span className="me-2 dst-icon-x-close text-danger" />
                  {translate(language, "PAGES.EVAL.DROPDOWN.UNCORRECT")}
                </Dropdown.Item>
              </DropdownButton>
            </div>
            <div className="w-100">
              <h4 className="m-bold">
                {item.resume}{" "}
                <span className="gray-font xs-regular ms-3">
                  {evaluationInfos.dt_start
                    ? formatSecondsMinutely(
                        Math.floor((item.timestamp - new Date(evaluationInfos.dt_start).getTime()) / 1000)
                      )
                    : "N/A"}
                </span>
              </h4>
              {renderIllustration(item.illustration)}
              {renderAnswer(item.answer, item.answer_programming_language)}
            </div>
          </div>
          <hr />
        </div>
      ))}
    </React.Fragment>
  );
};

export default HtmlEvaluationRender;
